import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
const FactoriesPage = () => {
    const columns = [
        { key: 'name', label: 'Factory Name', type: 'text', required: true },
        { key: 'code', label: 'Code', type: 'text' },
        {
            key: 'freight_factor',
            label: 'Freight Factor',
            type: 'select',
            options: [
                { value: 'Freight Factor 1', label: 'Freight Factor 1' },
                { value: 'Freight Factor 2', label: 'Freight Factor 2' },
            ],
        },
        { key: 'address', label: 'Address', type: 'text' },
        { key: 'city', label: 'City', type: 'text' },
        { key: 'state', label: 'State', type: 'text' },
        { key: 'zip_code', label: 'ZIP Code', type: 'text' },
        { key: 'country', label: 'Country', type: 'text' },
        { key: 'phone', label: 'Phone', type: 'text' },
        { key: 'email', label: 'Email', type: 'text' },
        { key: 'description', label: 'Description', type: 'text' },
        { key: 'sort_order', label: 'Sort Order', type: 'number', min: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "factories", title: "Factories", columns: columns, apiPath: "factories" }));
};
export default FactoriesPage;
